import { useCallback, useState } from "react";
import { useAtomValue } from "jotai";
import { BuilderFrameButton } from "@zapier/product-nav";
import {
  accountAtom,
  ownerAtomFamily_SUSPENDS,
  canvasAtom,
  entitlementsAtom_SUSPENDS,
} from "@zapier/canvas-state";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";
import { PermissionsModal } from "../modals/PermissionsModal";

export const LoadingShareButton = () => (
  <BuilderFrameButton disabled={true}>Share</BuilderFrameButton>
);

export default function ShareButton() {
  const account = useAtomValue(accountAtom);
  const canvas = useAtomValue(canvasAtom);
  const owner = useAtomValue(ownerAtomFamily_SUSPENDS(canvas.customuser_id));
  const entitlements = useAtomValue(entitlementsAtom_SUSPENDS);
  const hasMultipleTeams = Boolean(entitlements?.limits.is_teams_enabled);
  const { emitEventOnShareModalOpen } = useEmitUserInteractionEvents();

  const [showShareModal, setShowShareModal] = useState(false);

  const openShareModal = useCallback(() => {
    setShowShareModal(true);
    emitEventOnShareModalOpen();
  }, [setShowShareModal, emitEventOnShareModalOpen]);

  return (
    <span>
      <BuilderFrameButton onPress={openShareModal}>Share</BuilderFrameButton>
      {showShareModal && account && (
        <PermissionsModal
          account={account}
          hasMultipleTeams={hasMultipleTeams}
          owner={owner ?? undefined}
          onClosed={() => setShowShareModal(false)}
        />
      )}
    </span>
  );
}
